import * as Headless from '@headlessui/react';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

export const Link = function Link({
  ref,
  ...props
}: {
  ref?: React.RefObject<HTMLAnchorElement>;
} & React.ComponentPropsWithoutRef<'a'>) {
  return (
    <Headless.DataInteractive>
      <RouterLink {...props} to={props.href ?? ''} ref={ref} />
    </Headless.DataInteractive>
  );
};
